var getJSON = require('../DataAjaxCall/DataAjaxCall').DataAjaxCall;

var GetMeta = function(data) {

    var checkURL = data.url;
    if (checkURL) {
        // console.log('URL is NOT empty.. Call func getJSON()');
        var baseURL = checkURL;
        var jsonURL = baseURL + "/ajax.php?test/json";

        // But first check function
        var checkFunction = getJSON(jsonURL).startsWith("Cannot");

        if (checkFunction) {

            var content = '<div class="alert alert-info">' +
                'Preverite <strong>URL</strong>, ki ste ga vnesli za podatke.' +
                '<br>Nato preverite ali je JSON veljaven.' +
                '</div>' +
                '<div class="no-entries">' +
                '<i class="fa fa-info" aria-hidden="true"></i>' +
                'Graf ni mogoče izrisati.' +
                '</div>';

            $(".agen-data-graph").append(content);
            $(".agen-data-table").append(content);

        } else {
            var jsonString1 = getJSON(jsonURL);
            var processData = JSON.parse(jsonString1).meta;
            return processData;
        }
    } else {
        // console.log('URL is empty..'), check for embedded:
        if (data.embedded == undefined) {

            var content = '<div class="alert alert-info"> ' +
                'Knižnica Highcharts za Pie graf pričakuje nekateri <strong>vir podatkov</strong>.' +
                '<br>Prva opcija je, da dodate <strong>URL do podatke</strong>, ter druga opcija je, da dodate podatke <strong>embedded</strong>.' +
                '<br>Pričakovani JSON je:<br>[{ "meta": [{ ... }], "data": [{ ... }] }]' +
                '</div>' +
                '<div class="no-entries">' +
                '<i class="fa fa-info" aria-hidden="true"></i>' +
                'Graf ni mogoče izrisati.' +
                '</div>';

            $(".agen-data-graph").append(content);
            $(".agen-data-table").append(content);
        }

        var jsonString1 = JSON.stringify(data.embedded.meta);
        var processData = JSON.parse(jsonString1);
        return processData;
    }
}

exports.GetMeta = GetMeta;



//////////////////
// WEBPACK FOOTER
// ./src/modules/GetMeta/GetMeta.js
// module id = 5
// module chunks = 0